import { TimeOperation } from "namirasoft-core";
import { Component } from "react";

interface DurationProps
{
    started_at: Date | null;
    finished_at: Date | null;
}

interface DurationState
{
    now: Date;
}

class Duration extends Component<DurationProps, DurationState>
{
    private timer: ReturnType<typeof setInterval> | null = null;

    constructor(props: DurationProps)
    {
        super(props);
        this.state = { now: new Date() };
    }

    override componentDidMount(): void
    {
        this.scheduleTickIfNeeded();
    }

    override componentDidUpdate(prevProps: DurationProps): void
    {
        if (prevProps.started_at !== this.props.started_at || prevProps.finished_at !== this.props.finished_at)
            this.scheduleTickIfNeeded();
    }

    override componentWillUnmount(): void
    {
        this.clearTimer();
    }

    private clearTimer(): void
    {
        if (this.timer !== null)
        {
            clearInterval(this.timer);
            this.timer = null;
        }
    }

    private scheduleTickIfNeeded(): void
    {
        this.clearTimer();
        let { started_at, finished_at } = this.props;
        if (started_at && !finished_at)
            this.timer = setInterval(() => this.setState({ now: new Date() }), 500);
    }

    private format(start: Date, end: Date): string
    {
        let total = Math.max(0, Math.floor(TimeOperation.diffInSecond(end, start, true)));
        let h = Math.floor(total / 3600);
        let m = Math.floor((total % 3600) / 60);
        let s = total % 60;
        let pad = (n: number) => n.toString().padStart(2, "0");
        if (h > 0)
            return `${h}:${pad(m)}:${pad(s)}`;
        return `${pad(m)}:${pad(s)}`;
    }

    override render()
    {
        let { started_at, finished_at } = this.props;
        if (!started_at)
            return <>—</>;
        let start = new Date(started_at);
        let end = finished_at ? new Date(finished_at) : this.state.now;
        return <>{this.format(start, end)}</>;
    }
}

export default Duration;